import asCanvasElement from '../../utils/CanvasElement';
import ContainerElement from './ContainerElement';
import type { ContainerElementProps } from './types';
import { mapPristineOverrides } from './util';

export type { ContainerElementProps };
export default asCanvasElement(ContainerElement, mapPristineOverrides);
